// configs/orgA.config.js
export default {
  fhirVersion: "4.0.1",
  supportsBatch: true,
  clientId: "orgA_smart_client",
  scopes: "launch openid fhirUser patient/*.read",
  customLogo: "/logos/orgA.png",
  welcomeMessage: "Welcome to Aurora Health - charging money for health cause we can",
};
